import {
  addDayOffset,
  dateFromString,
  dateRangesOverlap,
  getHymnOfTheMonthDate,
  todayDate,
} from '../../../common/src/date_string.ts';
import { ClientOrg, OrgType, SongList, SongListType } from '../../../common/src/model.ts';
import { getSongListStartDate, hasInterval } from '../../../common/src/model_util.ts';
import { getSchoolTermDateRange, getWeeklyDateForOrganization } from '../../../common/src/org.ts';
import { localStorageGet, LocalStorageKey } from './client_local_storage.ts';

export function getWeeklySongLists(org: ClientOrg, songLists: SongList[]): SongList[] {
  const today = todayDate();
  let weeklySongLists: SongList[];
  if (org.type === OrgType.School) {
    const schoolTerms = localStorageGet(LocalStorageKey.SchoolTerms);
    const dateRange = getSchoolTermDateRange(schoolTerms, today);
    weeklySongLists = !dateRange
      ? []
      : songLists.filter((songList) => hasInterval(songList) && dateRangesOverlap(songList.interval, dateRange));
  } else {
    const hymnOfTheMonth = songLists.filter(
      (songList) =>
        songList.type === SongListType.HymnOfTheMonth &&
        getSongListStartDate(songList) === getHymnOfTheMonthDate(today),
    );

    const thisSundaySongList = songLists.filter((songList) => {
      return (
        songList.type === SongListType.WorshipService && songList.date === getWeeklyDateForOrganization(org, today)
      );
    });

    const lastSundaySongList = songLists.filter((songList) => {
      return (
        songList.type === SongListType.WorshipService &&
        songList.date === addDayOffset(getWeeklyDateForOrganization(org, today), -7)
      );
    });
    weeklySongLists = [...hymnOfTheMonth, ...thisSundaySongList, ...lastSundaySongList];
  }

  const oneWeekAgoDate = addDayOffset(today, -7);
  const twoWeeksOutDate = addDayOffset(today, 14);

  const pastEvents = songLists.filter((songList) => {
    return songList.type === SongListType.Event && songList.date < today && songList.date >= oneWeekAgoDate;
  });

  const todayEvents = songLists.filter((songList) => {
    return songList.type === SongListType.Event && songList.date === today;
  });

  const nearFutureEvents = songLists.filter((songList) => {
    return songList.type === SongListType.Event && songList.date > today && songList.date <= twoWeeksOutDate;
  });

  const allFutureEvents = songLists.filter((songList) => {
    return songList.type === SongListType.Event && dateFromString(songList.date) > dateFromString(today);
  });

  let futureEvents = nearFutureEvents;

  if (!nearFutureEvents.length && allFutureEvents.length > 0) {
    futureEvents = [allFutureEvents[0]!];
  }

  return [...weeklySongLists, ...todayEvents, ...futureEvents, ...pastEvents];
}
